<template>
  <div class="media-tile-content"><video ref="video" autoplay playsinline muted controls /><audio ref="audio" autoplay :muted="muted" /></div>
</template>
<script>
export default {
  props: ['stream', 'muted'],
  watch: { stream: { immediate: true, handler() { this.$nextTick(this.attach) } } },
  mounted() { this.attach() },
  methods: {
    attach() {
      if (!this.stream) return
      if (this.$refs.video) this.$refs.video.srcObject = this.stream
      if (this.$refs.audio) {
        this.$refs.audio.srcObject = this.stream
        this.$refs.audio.play().catch(() => {})
      }
    }
  }
}
</script>
